var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVijilize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18H4.49999C3.39542 17.9999 2.49999 17.1045 2.5 15.9999L2.50008 3.99999C2.50008 2.89542 3.39551 2 4.50008 2H13.5003C14.6049 2 15.5003 2.89543 15.5003 4V8M16.5 16.5L17.5 17.5M6.00031 6H12.0003M6.00031 9H12.0003M6.00031 12H9.00031M17 14.5C17 15.8807 15.8807 17 14.5 17C13.1193 17 12 15.8807 12 14.5C12 13.1193 13.1193 12 14.5 12C15.8807 12 17 13.1193 17 14.5Z",
    stroke: "#0A090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVijilize);
export default __webpack_public_path__ + "static/media/vijilize.8820cc11dcec486895c72fd1d74af977.svg";
export { ForwardRef as ReactComponent };